import { domains } from "@/mocks/home";
import { statusConfig } from "./status";

export default function DomainStrip() {
  return (
    <section id="domains" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full max-w-[1180px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-xs tracking-[0.2em] text-primary-700 uppercase">Entry Overview</p>
            <h4 className="mt-2 font-heading text-2xl md:text-3xl text-foreground-950">
              <a href="#domains" className="cursor-pointer hover:text-primary-700 transition-colors">
                当前可用域名速览
              </a>
            </h4>
            <p className="mt-3 text-sm text-foreground-600 max-w-2xl leading-relaxed">
              下面这些入口刚刚完成巡检。状态、线路和推荐场景都标好了，按需取用，失效的会及时标注。
            </p>
          </div>
          <span className="inline-flex items-center gap-1.5 self-start px-3 py-1.5 rounded-full bg-primary-100 text-primary-900 text-xs border border-primary-200 whitespace-nowrap">
            <i className="ri-radar-line"></i>
            共 {domains.length} 个入口 · 实时状态
          </span>
        </div>

        <div className="mt-8 rounded-lg border border-background-200 overflow-hidden bg-background-50">
          <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 bg-background-100 text-[12px] text-foreground-500 tracking-wide">
            <span className="col-span-3">入口名称</span>
            <span className="col-span-3">域名</span>
            <span className="col-span-1">线路</span>
            <span className="col-span-2">延迟</span>
            <span className="col-span-3">说明</span>
          </div>

          <ul className="divide-y divide-background-200">
            {domains.map((d) => {
              const cfg = statusConfig[d.status];
              return (
                <li
                  key={d.id}
                  className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-5 py-4 hover:bg-background-100 transition-colors"
                >
                  <div className="md:col-span-3 flex items-center gap-2">
                    <span className={`w-2 h-2 rounded-full ${cfg.dot}`}></span>
                    <span className="text-sm font-medium text-foreground-950">{d.label}</span>
                    <span
                      className={`ml-1 px-2 py-0.5 rounded-full text-[11px] border ${cfg.badge}`}
                    >
                      {cfg.label}
                    </span>
                  </div>
                  <div className="md:col-span-3 flex items-center">
                    <span className="text-sm text-foreground-700 font-mono truncate">{d.host}</span>
                  </div>
                  <div className="md:col-span-1 text-sm text-foreground-600">{d.region}</div>
                  <div className="md:col-span-2 text-sm text-foreground-700">
                    <i className="ri-speed-up-line mr-1 text-primary-600"></i>
                    {d.latency}
                  </div>
                  <div className="md:col-span-3 text-[13px] text-foreground-500">{d.note}</div>
                </li>
              );
            })}
          </ul>
        </div>

        <p className="mt-3 text-xs text-foreground-500 flex items-center gap-1.5">
          <i className="ri-information-line"></i>
          状态随时间变化，页面每 12 小时更新一次速览结果。
        </p>
      </div>
    </section>
  );
}